export const menuData = [
  { title: "Home", link: "/" },

  { title: "Teams", link: "/teams" },
  // { title: "Projects", link: "/apply.html" },
  { title: "Join Us", link: "/join-us" },
];
